import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './ProductsHome.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleDoubleRight,
    faFire,
    faGift,
    faShoePrints,
    faCompass,
    faArrowRight,
    faCalendarAlt,
    faStore,
    faShoppingBag,
    faTag,
    faChevronLeft,
    faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import 'react-toastify/dist/ReactToastify.css';
import LoadingProductos from '../LoadingProductos/LoadingProductos';
import { Link as Anchor, useParams } from "react-router-dom";
import moneda from '../moneda';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function ProductsHome() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Más vendido');
    const [tiendas, setTiendas] = useState([]);
    const categoriasInputRef = useRef(null);
    const swiperMasVendidoRef = useRef(null);


    const [eventos, setEventos] = useState([]);

    useEffect(() => {
        cargarProductos();
        cargarCategoria();
        cargarEventos();
    }, []);

    const shuffleArray = (array) => {
        const arr = [...array];
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    };

    const cargarEventos = () => {
        fetch(`${baseURL}/eventosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const lista = data.eventos || [];
                setEventos(shuffleArray(lista));
            })
            .catch(error => console.error('Error al cargar eventos:', error));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/tiendasFrontend.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const tiendasData = data.tiendas || [];
                setTiendas(tiendasData);
                const todosLosProductos = tiendasData.flatMap(tienda => tienda?.productos || []).filter(Boolean);
                setProductos(todosLosProductos);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        if (!item) return 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
        if (item.imagen1) return item.imagen1;
        if (item.imagen2) return item.imagen2;
        if (item.imagen3) return item.imagen3;
        if (item.imagen4) return item.imagen4;
        return 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
    };

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    const formatearRangoFechas = (inicio, fin) => {
        if (!inicio) return 'Próximamente';
        try {
            const dIni = new Date(inicio.replace(' ', 'T'));
            if (isNaN(dIni.getTime())) return inicio;
            const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            const diaIni = dIni.getDate();
            const mesIni = meses[dIni.getMonth()];

            if (fin) {
                const dFin = new Date(fin.replace(' ', 'T'));
                if (!isNaN(dFin.getTime())) {
                    const diaFin = dFin.getDate();
                    const mesFin = meses[dFin.getMonth()];
                    if (mesIni === mesFin) {
                        return `${diaIni} - ${diaFin} ${mesIni}`;
                    }
                    return `${diaIni} ${mesIni} - ${diaFin} ${mesFin}`;
                }
            }
            return `${diaIni} ${mesIni}`;
        } catch (e) {
            return inicio;
        }
    };

    const eventColors = ['#f59e0b', '#ec4899', '#3b82f6', '#10b981'];

    return (
        <div>

            {/* Gestión de Eventos & Actividades antes del menú Más Vendido */}
            <div className="homeFeaturedSection">
                <div className="homeFeaturedHeader">
                    <div className="homeFeaturedHeaderText">
                        <h3 className="homeFeaturedTitle">Eventos & Actividades</h3>
                        <p className="homeFeaturedSubtitle">Explora los eventos, ferias, aniversarios y actividades comerciales de nuestra comunidad</p>
                    </div>
                    <Anchor to="/eventos" className="btnVerTodoEventos" title="Ver todos los eventos y actividades">
                        <span>Ver todo</span>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </Anchor>
                </div>

                <div className="homeFeaturedCardsWrapper">
                    {eventos && eventos.length > 0 ? (
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={16}
                            grabCursor={true}
                            pagination={{ clickable: true }}
                            breakpoints={{
                                769: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                    allowTouchMove: false
                                }
                            }}
                            className="homeFeaturedSwiper"
                        >
                            {eventos.slice(0, 3).map((item, index) => {
                                const cardColor = eventColors[index % eventColors.length];
                                const fechaTexto = formatearRangoFechas(item.fecha_inicio, item.fecha_fin);
                                const slugTitulo = encodeURIComponent((item.titulo || 'evento').trim().replace(/\s+/g, '-'));

                                return (
                                    <SwiperSlide key={item.idEvento} className="featuredCardSlide">
                                        <Anchor
                                            to={`/evento/${item.idEvento}/${slugTitulo}`}
                                            className="featuredCard"
                                            style={{ '--accent-color': cardColor }}
                                            title={`Ver evento: ${item.titulo}`}
                                        >
                                            <div
                                                className="featuredCardBg"
                                                style={{ backgroundImage: `url(${item.imagen || 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&auto=format&fit=crop&q=80'})` }}
                                            />
                                            <div className="featuredCardOverlay" />

                                            <div className="featuredCardTop">
                                                <span className="featuredCardBadge">
                                                    <FontAwesomeIcon icon={faCalendarAlt} /> {fechaTexto}
                                                </span>
                                            </div>

                                            <div className="featuredCardBottom">
                                                <h4 className="featuredCardTitle">{item.titulo}</h4>
                                            </div>
                                        </Anchor>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    ) : null}
                </div>
            </div>

            {productos?.length > 0 && (
                <div className={`categoriasInputs ${fixedCategories ? 'fixed' : ''}`} ref={categoriasInputRef}>
                    <button
                        type="button"
                        className={`categoriaTabTitle ${categoriaSeleccionada === 'Más vendido' ? 'active' : ''}`}
                        onClick={() => handleClickCategoria('Más vendido')}
                    >
                        Más vendido
                    </button>
                    {categorias
                        .filter(categoria => productos.some(producto => Number(producto.idCategoria) === Number(categoria.idCategoria)))
                        .map(({ categoria, idCategoria }) => {
                            const label = categoria?.toLowerCase() === 'calzado' ? 'Calzados' : categoria;
                            return (
                                <button
                                    key={idCategoria}
                                    type="button"
                                    className={`categoriaTabTitle ${Number(categoriaSeleccionada) === Number(idCategoria) ? 'active' : ''}`}
                                    onClick={() => handleClickCategoria(idCategoria)}
                                >
                                    {label}
                                </button>
                            );
                        })}
                </div>
            )}

            {loading ? (
                <LoadingProductos />
            ) : (
                <div className='Products ProductsHomeContainer'>
                    {(() => {
                        const categoriaActual = categorias.find(c => Number(c.idCategoria) === Number(categoriaSeleccionada));
                        const nombreCategoria = categoriaSeleccionada === 'Más vendido'
                            ? 'Más Vendidos'
                            : (categoriaActual?.categoria || 'Productos');

                        const prodsFiltrados = categoriaSeleccionada === 'Más vendido'
                            ? productos
                            : productos.filter(item => Number(item.idCategoria) === Number(categoriaSeleccionada));

                        return (
                            <>
                                {/* ENCABEZADO DE CATEGORÍA SELECCIONADA ESTILO TIENDAS */}
                                <div className="categoriaProductosHeader">
                                    <div className="categoriaProductosHeaderTitle">
                                        <FontAwesomeIcon
                                            icon={categoriaSeleccionada === 'Más vendido' ? faFire : faShoppingBag}
                                            className="categoriaHeaderIcon"
                                            style={{ color: categoriaSeleccionada === 'Más vendido' ? '#f97316' : (categoriaActual?.color || 'var(--color1, #ff5722)') }}
                                        />
                                        <h3>
                                            Productos en <span>{nombreCategoria}</span>
                                        </h3>
                                    </div>
                                    <div className="categoriaProductosHeaderRight">
                                        {categoriaSeleccionada === 'Más vendido' && (
                                            <div className="carouselNavControls">
                                                <button
                                                    type="button"
                                                    className="carouselNavBtn"
                                                    onClick={() => swiperMasVendidoRef.current?.slidePrev()}
                                                    title="Producto anterior"
                                                    aria-label="Producto anterior"
                                                >
                                                    <FontAwesomeIcon icon={faChevronLeft} />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="carouselNavBtn"
                                                    onClick={() => swiperMasVendidoRef.current?.slideNext()}
                                                    title="Siguiente producto"
                                                    aria-label="Siguiente producto"
                                                >
                                                    <FontAwesomeIcon icon={faChevronRight} />
                                                </button>
                                            </div>
                                        )}
                                        <span className="categoriaProductosHeaderCount">
                                            {prodsFiltrados.length} {prodsFiltrados.length === 1 ? 'producto disponible' : 'productos disponibles'}
                                        </span>
                                    </div>
                                </div>

                                {/* CARRUSEL DESTACADO CUANDO ESTÁ EN MÁS VENDIDO */}
                                {categoriaSeleccionada === 'Más vendido' && (
                                    <div className='masVendidoSection'>
                                        {(() => {
                                            const prodsMasVendidos = productos.filter(item => item.masVendido === "si");
                                            const listaSliders = prodsMasVendidos.length > 0 ? prodsMasVendidos : productos.slice(0, 10);

                                            if (listaSliders.length === 0) return null;

                                            return (
                                                <div className='categoriSection'>
                                                    <Swiper
                                                        onSwiper={(swiper) => {
                                                            swiperMasVendidoRef.current = swiper;
                                                        }}
                                                        grabCursor={true}
                                                        slidesPerView={'auto'}
                                                        spaceBetween={16}
                                                        watchOverflow={true}
                                                        observer={true}
                                                        observeParents={true}
                                                        id='swiper_container_products'
                                                        className='swiperProductsMasVendido'
                                                        autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                                    >
                                                        {listaSliders.map(item => {
                                                            const slug = encodeURIComponent((item.titulo || 'producto').trim().replace(/\s+/g, '-'));
                                                            const tiendaProducto = tiendas?.find(t => t.idTienda === item.idTienda);
                                                            const catItem = categorias.find(c => Number(c.idCategoria) === Number(item.idCategoria));

                                                            return (
                                                                <SwiperSlide key={item.idProducto} className='slideMasVendidoTiendaStyle'>
                                                                    <Anchor
                                                                        className='cardProductoTiendaStyle'
                                                                        to={`/producto/${item.idProducto}/${slug}`}
                                                                        title={item.titulo}
                                                                    >
                                                                        <div className='imgProductoBannerWrapper'>
                                                                            <img
                                                                                src={obtenerImagen(item)}
                                                                                alt={item.titulo || "imagen"}
                                                                                className='imgProductoBanner'
                                                                                loading="lazy"
                                                                                decoding="async"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
                                                                                }}
                                                                            />
                                                                            <span className='categoriaBadgeProducto badgeMasVendido'>
                                                                                <FontAwesomeIcon icon={faFire} style={{ marginRight: '4px' }} />
                                                                                Más Vendido
                                                                            </span>
                                                                            <span className='badgePrecioProducto'>
                                                                                <span className='precioNumero'>
                                                                                    {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                                </span>
                                                                                {item.precioAnterior >= 1 && item.precioAnterior !== undefined && (
                                                                                    <span className='precioAnteriorBadge'>
                                                                                        {moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                                    </span>
                                                                                )}
                                                                            </span>
                                                                        </div>

                                                                        <div className='cardTextProductoTienda'>
                                                                            <img
                                                                                src={tiendaProducto?.imagen1 || 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60'}
                                                                                alt={tiendaProducto?.nombre || 'tienda'}
                                                                                className='CardlogoTiendaProducto'
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60';
                                                                                }}
                                                                            />
                                                                            <div className='cardTextInfoProducto'>
                                                                                <h4 title={item.titulo}>{item.titulo}</h4>
                                                                                {tiendaProducto && (
                                                                                    <h5 title={tiendaProducto.nombre}>
                                                                                        <FontAwesomeIcon icon={faStore} style={{ marginRight: '5px', fontSize: '11px', color: '#94a3b8' }} />
                                                                                        {tiendaProducto.nombre}
                                                                                    </h5>
                                                                                )}
                                                                                {item.descripcion && (
                                                                                    <p className='cardProductDesc'>{item.descripcion}</p>
                                                                                )}
                                                                            </div>
                                                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                                                        </div>
                                                                    </Anchor>
                                                                </SwiperSlide>
                                                            );
                                                        })}
                                                    </Swiper>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}

                                {/* GRILLA DE PRODUCTOS ESTILO TIENDAS */}
                                <div className='productosGridTiendaStyle'>
                                    {prodsFiltrados.length === 0 ? (
                                        <div className='noProductsMessage'>
                                            <p>No se encontraron productos disponibles en esta categoría por el momento.</p>
                                        </div>
                                    ) : (
                                        prodsFiltrados.map(item => {
                                            const slug = encodeURIComponent((item.titulo || 'producto').trim().replace(/\s+/g, '-'));
                                            const tiendaProducto = tiendas?.find(t => t.idTienda === item.idTienda);
                                            const catItem = categorias.find(c => Number(c.idCategoria) === Number(item.idCategoria));
                                            const badgeLabel = item.masVendido === 'si'
                                                ? 'Más Vendido'
                                                : (catItem?.categoria || nombreCategoria);

                                            return (
                                                <Anchor
                                                    key={item.idProducto}
                                                    to={`/producto/${item.idProducto}/${slug}`}
                                                    className='cardProductoTiendaStyle'
                                                    title={item.titulo}
                                                >
                                                    <div className='imgProductoBannerWrapper'>
                                                        <img
                                                            src={obtenerImagen(item)}
                                                            alt={item.titulo || "imagen"}
                                                            className='imgProductoBanner'
                                                            loading="lazy"
                                                            decoding="async"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60';
                                                            }}
                                                        />
                                                        <span className={`categoriaBadgeProducto ${item.masVendido === 'si' ? 'badgeMasVendido' : ''}`}>
                                                            {item.masVendido === 'si' && (
                                                                <FontAwesomeIcon icon={faFire} style={{ marginRight: '4px' }} />
                                                            )}
                                                            {badgeLabel}
                                                        </span>
                                                        <span className='badgePrecioProducto'>
                                                            <span className='precioNumero'>
                                                                {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                            </span>
                                                            {item.precioAnterior >= 1 && item.precioAnterior !== undefined && (
                                                                <span className='precioAnteriorBadge'>
                                                                    {moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </div>

                                                    <div className='cardTextProductoTienda'>
                                                        <img
                                                            src={tiendaProducto?.imagen1 || 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60'}
                                                            alt={tiendaProducto?.nombre || 'tienda'}
                                                            className='CardlogoTiendaProducto'
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=100&auto=format&fit=crop&q=60';
                                                            }}
                                                        />
                                                        <div className='cardTextInfoProducto'>
                                                            <h4 title={item.titulo}>{item.titulo}</h4>
                                                            {tiendaProducto && (
                                                                <h5 title={tiendaProducto.nombre}>
                                                                    <FontAwesomeIcon icon={faStore} style={{ marginRight: '5px', fontSize: '11px', color: '#94a3b8' }} />
                                                                    {tiendaProducto.nombre}
                                                                </h5>
                                                            )}
                                                            {item.descripcion && (
                                                                <p className='cardProductDesc'>{item.descripcion}</p>
                                                            )}
                                                        </div>
                                                        <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                                    </div>
                                                </Anchor>
                                            );
                                        })
                                    )}
                                </div>
                            </>
                        );
                    })()}
                </div>
            )}
        </div>
    );
}
